module.exports = __webpack_public_path__ + "Latinotype - CorporativeSansRd-Regular.73a7fb31198ec67805f9.otf";


//////////////////
// WEBPACK FOOTER
// /mnt/c/Dev/CoolDevs/modos/app/src/assets/fonts/Latinotype - CorporativeSansRd-Regular.otf
// module id = ../../../../../src/assets/fonts/Latinotype - CorporativeSansRd-Regular.otf
// module chunks = styles